import React, { useState } from "react";
import { PulseLoader } from "react-spinners";
import StepShell from "./StepShell";
import copy from "../copy";
import { PRIVACY_POLICY_URL } from "../config";

const ConsentStep = ({ onSubmit, submitting, onBack }) => {
  const c = copy.consent;
  const [accepted, setAccepted] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!accepted || submitting) return;
    setMessage("");
    const result = await onSubmit();
    if (result?.duplicate) setMessage(c.duplicate);
    else if (!result?.ok) setMessage(c.error);
  };

  return (
    <StepShell onBack={onBack}>
      <h1 className="rp-title rp-title--small">{c.title}</h1>
      <p className="rp-subtitle">{c.text}</p>
      <form className="rp-form rp-consent" noValidate onSubmit={submit}>
        <p className="rp-legal">
          {c.legalBefore}
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            {c.legalLink}
          </a>
          {c.legalAfter}
        </p>
        <label className="rp-check">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <span>{c.accept}</span>
        </label>
        {message && (
          <p className="rp-error" role="alert">
            {message}
          </p>
        )}
        <div className="rp-actions">
          <button
            type="submit"
            className="rp-btn"
            disabled={!accepted || submitting}
          >
            {submitting ? <PulseLoader color="#ffffff" size={8} /> : c.button}
          </button>
        </div>
      </form>
    </StepShell>
  );
};

export default ConsentStep;
